const TWENTY_FOUR_HOURS_IN_MS = 24 * 60 * 60 * 1000;

/**
 * Checks if the first date (d1) is 24 hours after the second date (d2)
 */
export function is24HoursAfter(d1: Date, d2: Date): boolean {
	const timeDifference = d1.getTime() - d2.getTime();
	return timeDifference >= TWENTY_FOUR_HOURS_IN_MS;
}
